module.exports = __webpack_public_path__ + "img/aqtobe7.23cdf995.jpg";